import { LOCALE_LABELS, useI18n } from '../i18n'

// CMS live-preview banner (iteration 0009). A fixed top bar shown only when the
// page renders inside the operator editor's preview (?preview=1), making it
// unmistakable that this is not the live site. A spacer of the same height keeps
// it from covering the nav.
const BAR_HEIGHT = 32

export default function PreviewBanner() {
  const { t, locale, preview } = useI18n()
  if (!preview) return null

  return (
    <>
      <div style={{ height: BAR_HEIGHT }} aria-hidden="true" />
      <div
        role="status"
        className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 bg-amber-400 px-4 text-center text-xs font-semibold text-amber-950"
        style={{ height: BAR_HEIGHT }}
      >
        <span className="rounded bg-amber-950/15 px-1.5 py-0.5 uppercase tracking-wide">
          {t('preview.badge')}
        </span>
        <span className="truncate">{t('preview.note')}</span>
        <span className="hidden shrink-0 opacity-70 sm:inline">· {LOCALE_LABELS[locale].full}</span>
      </div>
    </>
  )
}
